module.exports = __webpack_public_path__ + "img/xp_icon_st01.png";